import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom"; // Import React Router hooks
import Popup from "../Popup";
import { useAppDispatch } from "../../../../hooks/reduxHooks";
import { generateDesignData } from "../../../store/slices/viewSlice";
import { getDesignPDF } from "../../../api/editor.api";

const Preview = ({ show, setShow }: any) => {
  const [previewList, setPreviewList] = useState([]);
  const dispatch = useAppDispatch();
  const location = useLocation(); // Get the current URL
  const { designId } = useParams(); // Extract `designId` from the URL

  useEffect(() => {
    if (show) {
      generateImages();
    }
  }, [show]);

  const generateImages = () => {
    dispatch(generateDesignData({}))
      .unwrap()
      .then((data: any) => {
        const newData: any = [];
        for (const key in data) {
          if (Object.prototype.hasOwnProperty.call(data, key)) {
            const element = data[key];
            newData.push(element);
          }
        }
        setPreviewList(newData);
      });
  };

  const handleDownload = (imageUrl: string, imageName: string) => {
    const link = document.createElement("a");
    link.href = imageUrl;
    link.download = imageName || "download";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handlePrintPDF = async () => {
    if (!designId) return; // Ensure `designId` exists

    try {
      const pdfData = await getDesignPDF(designId); // Use getDesignPDF to fetch the PDF
      debugger;
      const pdfBlob = new Blob([pdfData], { type: "application/pdf" }); // Create a Blob from the data
      const pdfURL = URL.createObjectURL(pdfBlob); // Create a URL for the PDF Blob

      // Open the PDF in a new tab for printing
      const pdfWindow = window.open();
      if (pdfWindow) {
        pdfWindow.location.href = pdfURL;
      }
    } catch (error) {
      console.error("Error fetching the PDF:", error);
    }
  };

  const isEditMode = location.pathname.includes("/edit-designing/"); // Check if URL is in edit mode

  return (
    <Popup show={show} setShow={setShow} title="Preview">
      <div className="grid gap-2 p-3">
        {previewList.map((data: any) => {
          return (
            <div key={data.name} style={{ position: "relative" }}>
              {/* Download Button */}
              <button
                onClick={() => handleDownload(data.image_url, data.name)}
                type="button"
                title="Download"
                style={{
                  position: "absolute",
                  top: 5,
                  left: 5,
                  width: 24,
                  height: 24,
                  backgroundColor: "white",
                  border: "none",
                  padding: "10px",
                  cursor: "pointer",
                  borderRadius: "5px",
                }}
              >
                <svg
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17 17H17.01M17.4 14H18C18.9319 14 19.3978 14 19.7654 14.1522C20.2554 14.3552 20.6448 14.7446 20.8478 15.2346C21 15.6022 21 16.0681 21 17C21 17.9319 21 18.3978 20.8478 18.7654C20.6448 19.2554 20.2554 19.6448 19.7654 19.8478C19.3978 20 18.9319 20 18 20H6C5.06812 20 4.60218 20 4.23463 19.8478C3.74458 19.6448 3.35523 19.2554 3.15224 18.7654C3 18.3978 3 17.9319 3 17C3 16.0681 3 15.6022 3.15224 15.2346C3.35523 14.7446 3.74458 14.3552 4.23463 14.1522C4.60218 14 5.06812 14 6 14H6.6M12 15V4M12 15L9 12M12 15L15 12"
                    stroke="#000000"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>

              {/* Print PDF Button (only in edit mode) */}
              {isEditMode && (
                <button
                  onClick={handlePrintPDF}
                  type="button"
                  title="Download The PDF"
                  style={{
                    position: "absolute",
                    top: 5,
                    right: 5,
                    width: 24,
                    height: 24,
                    backgroundColor: "white",
                    border: "none",
                    padding: "10px",
                    cursor: "pointer",
                    borderRadius: "5px",
                  }}
                >
                  <svg
                    fill="#000000"
                    height="24px"
                    width="24px"
                    version="1.1"
                    id="Layer_1"
                    viewBox="0 0 64 64"
                    enable-background="new 0 0 64 64"
                  >
                    <g id="Printer">
                      <path
                        d="M57.7881012,14.03125H52.5v-8.0625c0-2.2091999-1.7909012-4-4-4h-33c-2.2091999,0-4,1.7908001-4,4v8.0625H6.2119002
		C2.7871001,14.03125,0,16.8183498,0,20.2431507V46.513649c0,3.4248009,2.7871001,6.2119026,6.2119002,6.2119026h2.3798995
		c0.5527,0,1-0.4472008,1-1c0-0.5527-0.4473-1-1-1H6.2119002C3.8896,50.7255516,2,48.8359489,2,46.513649V20.2431507
		c0-2.3223,1.8896-4.2119007,4.2119002-4.2119007h51.5762024C60.1102982,16.03125,62,17.9208508,62,20.2431507V46.513649
		c0,2.3223-1.8897018,4.2119026-4.2118988,4.2119026H56c-0.5527992,0-1,0.4473-1,1c0,0.5527992,0.4472008,1,1,1h1.7881012
		C61.2128983,52.7255516,64,49.9384499,64,46.513649V20.2431507C64,16.8183498,61.2128983,14.03125,57.7881012,14.03125z
		 M13.5,5.96875c0-1.1027999,0.8971996-2,2-2h33c1.1027985,0,2,0.8972001,2,2v8h-37V5.96875z"
                      />
                      <path
                        d="M44,45.0322495H20c-0.5517998,0-0.9990005,0.4472008-0.9990005,0.9990005S19.4482002,47.0302505,20,47.0302505h24
		c0.5517006,0,0.9990005-0.4472008,0.9990005-0.9990005S44.5517006,45.0322495,44,45.0322495z"
                      />
                      <path
                        d="M44,52.0322495H20c-0.5517998,0-0.9990005,0.4472008-0.9990005,0.9990005S19.4482002,54.0302505,20,54.0302505h24
		c0.5517006,0,0.9990005-0.4472008,0.9990005-0.9990005S44.5517006,52.0322495,44,52.0322495z"
                      />
                      <circle cx="7.9590998" cy="21.8405495" r="2" />
                      <circle cx="14.2856998" cy="21.8405495" r="2" />
                      <circle cx="20.6121998" cy="21.8405495" r="2" />
                      <path d="M11,62.03125h42v-26H11V62.03125z M13.4036999,38.4349518h37.1925964v21.1925964H13.4036999V38.4349518z" />
                    </g>
                  </svg>
                </button>
              )}

              <img src={data.image_url} alt={data.name} />
              <div style={{ textAlign: "center", fontWeight: "bold" }}>
                {data.name}
              </div>
            </div>
          );
        })}
      </div>
    </Popup>
  );
};

export default Preview;
